<template>
    <div id="content">
        <loader></loader>
        <div class="top">
            <div class="header">
                <h1>{{ customer.company }} - {{ questionnaire.reason.label }} - Questionnaire </h1>
                <div class="pageOptions">
                    <btn text="Information" ico="config" @click="informations" v-if="customer.informations"></btn>
                    <btn text="Enregistrer" ico="valide" @click="save"
                         v-if="$store.getters.hasPerm('response:add/edit') && !isLocked && !preview"></btn>
                    <btn ico="times" color="red" @click="cancel"
                         v-if="$store.getters.hasPerm('response:add/edit')"></btn>
                </div>
            </div>
            <div v-if="createAt !== 0">
                Répondu le : {{ createAt|formatDateHour }}
            </div>
        </div>
        <div class="double" ref="responseTop">
            <form class="responses" ref="responses" autocomplete="off">
                <Question v-for="(question,k) in questions" :key="k" :k="k" :question="question"
                          :response="responses[k]" :locked="isLocked"
                          v-if="condition(question,k) && isLoaded" @textfocus="blockAnim = true"
                          @textblur="blockAnim = false" :newClass="newQuestions[k] > 0"></Question>
            </form>
            <div class="response-resume">
                <div class="response-content" :style="{top:resumeTop+'px'}">
                    <h3>Résumé</h3>
                    <div v-for="(question,k) in questions" class="resume" v-if="resume(question,k)">
                        <p class="title" v-html="showQuestionText(question)"></p>
                        <p class="response">{{ showResponses(question, k) }}</p>
                    </div>
                </div>
            </div>
        </div>
        <transition name="fade" mode="out-in">
            <div id="new-question" v-show="newQuestion > 0">
                Nouvelle question disponible
            </div>
        </transition>
    </div>
</template>

<script>
import axios from 'axios';
import tools from '../config.ts';
import Btn from "@/components/Btn";
import Loader from "@/components/Loader";
import Question from "@/components/response/Question";
import anime from "animejs";

export default {
    name: "Response",
    components: {Question, Loader, Btn},
    data() {
        return {
            questionnaireId: 0,
            customerId: 0,
            responseId: 0,
            
            isLoaded: false,
            questionnaire: {reason: {}},
            questions: {},
            responses: [],
            customer: {},
            preview: false,
            
            createAt: 0,
            resumeTop: 0,
            
            blockAnim: false,
            newQuestion: 0,
            newQuestions: [],
        }
    },
    methods: {
        
        load() {
            
            axios.get(tools.api("questionnaire/" + this.questionnaireId), tools.headerGET())
                .then((response) => {
                    this.questionnaire = response.data;
                    this.questions = JSON.parse(this.questionnaire.questions);
                    
                    if (this.responseId) {
                        this.loadResponse();
                        return;
                    }
                    
                    tools.loader(false);
                    this.questions.forEach((question) => {
                        let values = [];
                        question.content.forEach((content) => {
                            values.push("");
                        });
                        this.responses.push({
                            question: question.id,
                            value: values,
                        });
                        this.newQuestions.push(0);
                    });
    
                    console.log(this.questionConditionValide);
                    
                    this.isLoaded = true;
                    
                })
                .catch((e) => {
                    console.log(e)
                    tools.loader(false);
                })
        },
        loadResponse() {
            
            axios.get(tools.api("customer/" + this.customerId + "/questionnaire/" + this.questionnaireId + "/response/" + this.responseId), tools.headerGET())
                .then((response) => {
                    
                    tools.loader(false);
                    
                    this.createAt = response.data.createAt;
                    this.responses = JSON.parse(response.data.responses);
                    
                    // console.log(this.responses)
                    
                    this.isLoaded = true;
                })
        },
        loadCustomer() {
            axios.get(tools.api("customer/" + this.customerId), tools.headerGET())
                .then((response) => {
                    this.customer = response.data;
                })
        },
        
        save() {
            
            let responses = JSON.stringify(this.responses);
            
            // console.log(responses);
            
            let url = "response";
            if (this.responseId) {
                url += "/" + this.responseId
            }
            
            let datas = {
                customer_id: this.customerId,
                questionnaire_id: this.questionnaireId,
                responses: responses
            }
            
            axios.post(tools.api(url), tools.toPOST(datas), tools.headerPOST())
                .then((response) => {
                    
                    tools.loader(false);
                    
                    if (!tools.isSuccessResponse(response)) {
                        return tools.popup("valid", {
                            title: "Erreur",
                            message: "Erreur lors de l'enregistrement des réponses",
                        });
                    }
                    
                    if (!this.responseId) {
                        this.$store.commit("setResponseId", response.data.response_id);
                        this.$router.push("/call/add");
                    } else {
                        this.$router.push("/customer/" + this.customerId + "/questionnaires/" + this.questionnaireId + "/reponses")
                    }
                })
                .catch((error) => {
                    tools.loader(false);
                    tools.popup("valid", {
                        title: "Erreur",
                        message: "Erreur lors de l'enregistrement des réponses. <br/><br/>Détail de l'erreur : <br/>" + tools.parseError(error)
                    })
                })
        },
        cancel() {
            
            if (this.isLocked) {
                this.$router.back();
                return
            }
            
            tools.popup("confirm", {
                title: "Confirmation",
                message: "Voulez-vous vraiment annuler les réponses ?",
                success: () => {
                    this.$router.back();
                }
            })
        },
        
        // calculConditionQuestion(){
        //     console.log(this.questions)
        //
        //     let conditions = {};
        //     let conditionsInverse = {};
        //     let blocksIds = 0;
        //     let conditionId = 0;
        //
        //     this.questions.forEach((question, questionKey) => {
        //
        //         if(question.conditions.length === 0){
        //             console.log("AFFICHE Q:"+question.id+" ["+questionKey+"]")
        //             return;
        //         }
        //
        //         let msgCondition = {}
        //         let pattern = question.pattern;
        //         if(!pattern){
        //             pattern = " condition_1 ";
        //         }
        //         //
        //         // let blocks = pattern.match(/(\(.*?\))/g)
        //         //
        //         // if(blocks) {
        //         //     // conditions[blocksIds]
        //         //     blocks.forEach((block) => {
        //         //
        //         //
        //         //     })
        //         //     blocksIds++
        //         // }
        //
        //         // console.log(blocks)
        //
        //        /* let Ors = pattern.split("OU");
        //
        //         Ors.forEach((Or,k) => {
        //
        //             let Ands = Or.split("ET")
        //
        //             Ands.forEach((And,i) => {
        //                 console.log(And)
        //                 let condition = parseInt(And.replace(/[condit_(]+(\d)\)?/, "$1").trim());
        //
        //                 if(!question.conditions[condition -1]) return;
        //
        //                 if(!conditions[question.id])conditions[question.id] = {
        //                     pattern:pattern,
        //                     OR: {}
        //                 }
        //
        //                 if(!conditions[question.id].OR[k]) conditions[question.id].OR[k] = []
        //
        //                 conditions[question.id].OR[k].push({
        //                     question : question.conditions[condition - 1].question,
        //                     response : question.conditions[condition - 1].responses,
        //                 })
        //
        //                 // let q = question.conditions[condition - 1].question;
        //                 // let r = question.conditions[condition - 1].responses;
        //                 //
        //                 // if(!conditionsInverse[q]) conditionsInverse[q] = {};
        //                 // if(!conditionsInverse[q][r.equal]) conditionsInverse[q][r.equal] = {};
        //                 //
        //                 // conditionsInverse[q][r.equal][r.value] = question.id;
        //
        //             })
        //
        //         })*/
        //
        //         question.conditions.forEach((condition,k) => {
        //             if(!conditions[question.id]) conditions[question.id] = {};
        //             conditions[question.id]["condition_"+k] = {
        //                 questionId : condition.question,
        //                 equal : condition.responses.equal,
        //                 value : condition.responses.value
        //             };
        //         })
        //
        //         let msg = "SI "
        //
        //         let regex = new RegExp("[OUET]+ +condition_.")
        //         if(pattern.match(regex)){
        //             pattern = pattern.replace(regex,"")
        //         }
        //
        //         msg += pattern;
        //         msg +=  "ALORS Affiche Q:"+question.id+"["+questionKey+"]";
        //         console.log(msg)
        //
        //     })
        //     console.log(conditions)
        //     console.log(conditionsInverse)
        // },
        condition(question,questionKey){
    
            // si la question n'a pas de condition on l'affiche
            if (question.conditions.length <= 0) {
                question.show = true;
                return true;
            }
            
            // on recrée le pattern
            let pattern = question.pattern
            if(!pattern){
                pattern = "";
                question.conditions.forEach((condition,key) => {
                    pattern += "condition_"+(key+1)+" ET "
                });
                pattern = pattern.substr(0,pattern.length - 4);
            }
            
            let show = false;
            // on lit le pattern condition par condition
            let Ors = pattern.split("OU");
            
            Ors.forEach((Or,k) => {
                
                if(show) return;
                
                let Ands = Or.split("ET")
                let nbAnd = 0;
                let total = 0;
                Ands.forEach((And,i) => {
                    
                    let condition = parseInt(And.replace(/[condit_(]+(\d)\)?/, "$1").trim());

                    if(!question.conditions[condition -1] || !this.questionConditionValide[question.id]){
                        // console.log("erreur questionKey "+questionKey+"[id:"+question.id+"] => ")
                        return;
                    }
                    
                    if(this.questionConditionValide[question.id]["condition_"+(condition - 1)].valide){
                        total ++;
                    }
                    
                    nbAnd++;

                })
    
                if(total === nbAnd && total > 0){
                    // console.log("questionKey "+questionKey+"[id:"+question.id+"] => total:"+total+"; nbAdd:"+nbAnd+"; show:"+(total === nbAnd && total > 0))
                    show = true;
                }
            });
    
            if (show && !question.show && !this.isLocked) {
    
                // console.log({question})
                // console.log({pattern})
                // console.log(this.questionConditionValide[question.id])
                //
                //
                // on pré-rempli les réponses pour que ca ne crée pas d'erreur dans la calcul des conditions
                let values = [];
        
                question.content.forEach(() => {
                    values.push("");
                });
        
                this.responses[questionKey].value = values;
        
                // on joue 2 animations pour notifié de la nouvelle question
                this.newQuestions[questionKey] = setTimeout(() => {
                    this.newQuestions[questionKey] = 0
                }, 3000)
        
                clearTimeout(this.newQuestion)
        
                this.newQuestion = setTimeout(() => {
                    this.newQuestion = 0
                }, 3000)
        
            }
    
            if(!show && question.show){
                let values = [];
    
                question.content.forEach(() => {
                    values.push("");
                });
    
                this.responses[questionKey].value = values;
            }
    
            question.show = show
            
            return show;
        },
        /*condition_old(question, k) {
            
            // si la question n'a pas de condition on l'affiche
            if (question.conditions.length <= 0) {
                question.show = true;
                return true;
            }
            
            // on récupère le pattern
            let questionPattern = question.pattern || ""; // (condition_1 ET condition_2) OU condition_3
            let conditionValide = {};
            
            let prevShow = question.show;
            question.show = false;
    
            // for each condition in the question
            question.conditions.forEach((condition, key) => {
                
                let quest = this.getQuestionById(condition.question);
                let response = this.getResponseByQuestionId(condition.question);
    
                conditionValide[key] = false;
                
                // si la question n'a pas de réponse possible on annule la condition, bug de conception, il n'est normalement pas possible d'avoir une question sans réponse comme condition
                if (!response) {
                    return;
                }
                // /!\ ?????????????????????????????????
                if (!condition.responses.value) {
                    console.log(condition)
                    condition.responses.value = "";
                }
                
                // si le pattern est null on en crée un (rétrocompatiblité)
                if (!question.pattern) {
                    questionPattern += " condition_" + (key + 1) + " ET ";
                }
                
                // si la question n'est pas visible on annule la condition
                if (!quest.show) {
                    return;
                }
                
                let value = condition.responses.value;
                value = value.replace(/\(/g, "\\(");
                value = value.replace(/\)/g, "\\)");
                value = value.replace(/\[/g, "\\[");
                value = value.replace(/\]/g, "\\]");
                value = value.replace(/\-/g, "\\-");
                value = value.replace(/\+/g, "\\+");
                value = value.replace(/\*!/g, "\\*");
                value = value.replace(/\//g, "\\/");
                value = value.replace(/\</g, "\\<");
                
                let regex = new RegExp(value);
                
                response.value.forEach((value) => {
                    
                    switch (condition.responses.equal) {
                        case "equal":
                            if (value == condition.responses.value) {
                                conditionValide[key] = true;
                            }
                            break;
                        case "contain":
                            if (value.match(regex)) {
                                conditionValide[key] = true;
                            }
                            break;
                        case "not-equal":
                            if (value != condition.responses.value) {
                                conditionValide[key] = true;
                            }
                            break;
                        case "not-contain":
                            if (!value.match(regex)) {
                                conditionValide[key] = true;
                            }
                            break;
                    }
                })
            });
            
            // si le pattern est null et qu'il a été créer automatiquement, on retir le dernier ET
            if (!question.pattern && questionPattern !== "") {
                questionPattern = questionPattern.substr(0, questionPattern.length - 4);
            }
            
            // si il n'y a qu'une condition et qu'elle est valide on shut la vérification du pattern
            if(question.conditions.length === 1 && conditionValide[0]){
                
                question.show = true;
                
            }else{
                
                // On parse le patterne pour reconstituer les conditions
                let Ors = questionPattern.split("OU");
    
                // on commence par les OU
                Ors.forEach((Or) => {
        
                    // on parse les ET entre 2 OU
                    let Ands = Or.split("ET");
                    let total = 0;
                    Ands.forEach((And) => {
            
                        // on récupère la clé de la condition stocké dans le pattern (+1)
                        let condition = parseInt(And.replace(/[condit_(]+(\d)\)?/, "$1").trim());
                        let conditionKey = (condition - 1).toString();
            
                        if (conditionValide[conditionKey]) {
                            total++;
                        }
                    });
        
                    // si le nombre de condition renseigné dans la question est == au nombre de condition valide
                    if (Ands.length > 0 && total === Ands.length) {
                        question.show = true;
                    }
                });
            }
            
            // si la question s'affiche pour la première fois et que le questionnaire n'est pas vérouillé
            if (question.show && !prevShow && !this.isLocked) {
                
                // on pré-rempli les réponses pour que ca ne crée pas d'erreur dans la calcul des conditions
                let values = [];
                
                question.content.forEach(() => {
                    values.push("");
                });
                
                this.responses[k].value = values;
                
                // on joue 2 animations pour notifié de la nouvelle question
                this.newQuestions[k] = setTimeout(() => {
                    this.newQuestions[k] = 0
                }, 3000)
                
                clearTimeout(this.newQuestion)
                
                this.newQuestion = setTimeout(() => {
                    this.newQuestion = 0
                }, 3000)
                
            }
            
            // on retourne si on affiche ou non la question
            return question.show;
            
        },*/
        resume(question, k) {
            
            
            if (!question.show) {
                return false;
            }
            
            if (!question.resume) {
                return false;
            }
            
            let response = this.getResponseByQuestionId(question.id);
            // console.log("------------[" + question.id + "]-----------------");
            // console.log(response);
            if (!response) {
                return false;
            }
            for (let i = 0; i < response.value.length; i++) {
                // console.log(response.value[i]);
                if (response.value[i] !== "") {
                    return true;
                }
            }
            
            return false;
        },
        showResponses(question, k) {
            let response = this.getResponseByQuestionId(question.id);
            
            let res = "";
            response.value.forEach((val) => {
                if (val !== "") {
                    res += val + ", ";
                }
            });
            
            res = res.substr(0, res.length - 2);
            return res;
        },
        showQuestionText(question) {
            if (question.labelText) {
                return question.labelText;
            }
            return question.label
        },
        getQuestionById(questionId) {
            return this.questions.filter((question) => question.id === questionId)[0]
        },
        getResponseByQuestionId(questionId) {
            return this.responses.filter((response) => response.question === questionId)[0]
        },
        isCheckbox(question) {
            return question.type === 'checkbox' || question.type === 'radio' || question.type === 'select';
        },
        informations() {
            if (this.customer.informations) {
                tools.popup("valid", {
                    title: "Informations",
                    message: this.customer.informations
                })
            }
        },
        
        questionIsValide(condition){
    
            let question = this.getQuestionById(condition.question);
            let response = this.getResponseByQuestionId(condition.question);
            
            if(!question) return false;
            
            if(!question.show && question.conditions.length === 0){
                question.show = true;
            }
            // si il n'y a pas de réponse ou si la question n'est pas affiché
            if(!response || !question.show) return false;
            
            let value = condition.responses.value;
            if(!value) value = "";
            value = value.replace(/\(/g, "\\(")
                        .replace(/\)/g, "\\)")
                        .replace(/\[/g, "\\[")
                        .replace(/\]/g, "\\]")
                        .replace(/\-/g, "\\-")
                        .replace(/\+/g, "\\+")
                        .replace(/\*/g, "\\*")
                        .replace(/\//g, "\\/")
                        .replace(/\</g, "\\<")
    
            let regex = new RegExp(value);
            let equal = condition.responses.equal;
            let responsesValide = false;
            
            if(equal === "not-equal" || equal === "not-contain"){
                responsesValide = true;
            }
            
            // cas particulier pour les différent de vide
            if(equal === "not-equal" && condition.responses.value === ""){
                responsesValide = true;
                let vide = 0
                response.value.forEach((value) => {
                    if(value == ""){
                        vide++;
                    }
                })
                if(vide === response.value.length){
                    responsesValide = false;
                }
                return responsesValide;
            }
            
            response.value.forEach((value) => {
        
                switch (equal) {
                    case "equal":
                        if (value == condition.responses.value) {
                            responsesValide = true;
                        }
                        break;
                    case "contain":
                        if (value.match(regex)) {
                            responsesValide = true;
                        }
                        break;
                    case "not-equal":
                        if(condition.question == 5){
                            console.log("value : "+value)
                            console.log("condition.responses.value) : "+condition.responses.value)
                        }
    
                        if (value == condition.responses.value) {
                            responsesValide = false;
                        }
                        break;
                    case "not-contain":
                        if (value.match(regex)) {
                            responsesValide = false;
                        }
                        break;
                }
            })
            
            return responsesValide;
        }
    },
    computed: {
        
        isLocked() {
            return this.responseId > 0;
        },
        
        questionConditionValide(){
            let conditions = {};
            let conditionsSave = {};
            
            this.questions.forEach((question, questionKey) => {
                question.conditions.forEach((condition, k) => {
                    if (!conditions[question.id]) {
                        conditions[question.id] = {};
                    }
                    else if(conditions[question.id]["condition_"+k]) {
                        question.id = question.id+"_"+questionKey;
                        conditions[question.id] = {};
                    }
    // console.log(condition.question+"|"+condition.responses.equal+"|"+condition.responses.value)
                    let value = condition.responses.value;
                    if(!value) value = "";
                    
                    if(!conditionsSave[condition.question+"|"+condition.responses.equal+"|"+value.trim()]) {
                        conditionsSave[condition.question + "|" + condition.responses.equal + "|" + value.trim()] = this.questionIsValide(condition)
                    }
                    
                    conditions[question.id]["condition_" + k] = {
                        questionId: condition.question,
                        questionKey : questionKey,
                        equal: condition.responses.equal,
                        value: condition.responses.value,
                        valide:conditionsSave[condition.question+"|"+condition.responses.equal+"|"+value.trim()]
                    };
                    // console.log(question.id,conditions[question.id]["condition_" + k])
                })
            })
            console.log(conditions)
            console.log(conditionsSave)
            return conditions;
        }
        
    },
    watch: {
        responses(val) {
            // console.log(val)
        }
    },
    mounted() {
        
        if (!this.$store.getters.hasPerm('response:add/edit')) {
            return this.$router.back();
        }
        
        this.questionnaireId = this.$route.params.questionnaire_id;
        this.customerId = this.$route.params.customer_id;
        this.responseId = this.$route.params.response_id;
        
        if (this.responseId === "preview") {
            this.responseId = 0;
            this.preview = true;
        }
        
        this.$store.commit("onEditMode", true);
        
        tools.loader(true);
        
        tools.$on("newResponse", (key, value) => {
            this.$set(this.responses, key, value);
        })
        
        this.resumeTop = this.$refs.responseTop.getBoundingClientRect().top;
    
        this.load();
        this.loadCustomer();
        
    }
}
</script>